import React, { Component } from 'react';
import './App.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

  class FilterBar extends Component {
    constructor(){
      super()
      this.state = {
        filter1: '',
        filter2: '',
        filter3: ''
      }
      this.updateFilter1 = this.updateFilter1.bind(this);
      this.updateFilter2 = this.updateFilter2.bind(this);
      this.updateFilter3 = this.updateFilter3.bind(this);
      this.clearValue = this.clearValue.bind(this);
    }
    clearValue (e) {
      this.select.setInputValue('');
    }
    updateFilter1 (newValue) {
      this.props.update2({property: newValue})
    }
    updateFilter2 (newValue) {
      //console.log("NEW VALUE ", newValue)
      if(this.props.ph2Filter === "Interior | Exterior"){
          //console.log("newValue", newValue)
          this.props.update2({interiorExterior: newValue})
      } else {
          this.props.update2({bedroomType: newValue})
      }
    }
    updateFilter3 (newValue) {
      this.props.update2({city: newValue})
    }
    render () {
      return (
        <div className="section filterContainer">
          <div className="flex-container filterWidthContainer">
            <div className="flex-container filterHeadingContainer">
              <div className="filterHeading">Filter By:</div>
              <div className="clearContainer mobileClearContainer"><button disabled={this.props.clearButtonDisabled} className="clearBtn" type="button" onClick={this.props.clearValues}>Clear</button></div>
            </div>

            <div className="inline-block selectContainer col-sm-12">
              <Select
                id="state-select"
                ref={(ref) => { this.select = ref; }}
                onBlurResetsInput={false}
                onSelectResetsInput={false}
                clearable={false}
                options={this.props.filter1}
                simpleValue
                name="selected-state"
                value={this.props.property}
                onChange={this.updateFilter1}
                placeholder={this.props.ph1Filter}
                searchable={false}
              />
            </div>
            <div className="inline-block selectContainer col-sm-12">
              <Select
                id="state-select"
                ref={(ref) => { this.select = ref; }}
                onBlurResetsInput={false}
                onSelectResetsInput={false}
                clearable={false}
                options={this.props.filter2}
                simpleValue
                name="selected-state"
                value={this.props.bedroomType || this.props.interiorExterior}
                onChange={this.updateFilter2}
                placeholder={this.props.ph2Filter}
                searchable={false}
              />
            </div>
            <div className="inline-block selectContainer col-sm-12">
              <Select
                id="state-select"
                ref={(ref) => { this.select = ref; }}
                onBlurResetsInput={false}
                onSelectResetsInput={false}
                clearable={false}
                options={this.props.filter3}
                simpleValue
                name="selected-state"
                value={this.props.city}
                onChange={this.updateFilter3}
                disabled={this.props.cityDisabled}
                placeholder={this.props.ph3Filter}
                searchable={false}
              />
            </div>
            <div className="clearContainer"><button disabled={this.props.clearButtonDisabled} className="clearBtn" type="button" onClick={this.props.clearValues}>Clear</button></div>
          </div>
        </div>
      );
    }
  }


export default FilterBar;



// WEBPACK FOOTER //
// ./src/FilterBar.js